import _ from 'lodash'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Header } from 'semantic-ui-react'
import { getClient } from '../actions/clients'
import clientsSelectors from '../selectors/clients'

import './LoginHeader.scss';

export default ({ site }: {site: string}) => {
  const dispatch = useDispatch();
  const getClientSelector = useSelector(clientsSelectors.getClient);
  const header = _.get(getClientSelector, 'payload.data.attributes.name');
  useEffect(() => {
    if(!getClientSelector.payload) dispatch(getClient(site))
  }, [dispatch, getClientSelector.payload, site]);
  return (
    <div className="LoginHeader">
      { header &&
      <Header>{header}</Header>
      }
    </div>
  );
}
